import * as THREE from 'three';

export default class BonesMaterial extends THREE.RawShaderMaterial {
  constructor(props = {}) {
    super();

    // Merge custom props with default options
    const opts = Object.assign(
      {
        color: new THREE.Color('#ffffff'),
        opacity: 1.0,
      },
      props,
    );

    this.name = 'BonesMaterial';
    this.glslVersion = THREE.GLSL3;
    this.depthTest = false;
    this.depthWrite = false;
    this.transparent = true;
    this.blending = THREE.NormalBlending;
    // this.alphaToCoverage = true;
    this.side = THREE.DoubleSide;
    // this.lights = false;

    this.uniforms = {
      color: { value: opts.color },
      opacity: { value: opts.opacity },
    };

    this.vertexShader = `
        in vec3 position; // Vertex Position
        in vec3 normal;   // Vertex Normal Direction
        in vec2 uv;       // Vertex Texture UV Coordinate

        uniform mat4 modelMatrix;       // To WorldSpace
        uniform mat4 viewMatrix;        // To ViewSpace
        uniform mat4 projectionMatrix;  // To NDC ( Normalized Device Coordinate Space ) aka ScreenSpace
 
        out vec3 fragWPos;
        out vec3 fragWNorm;
        out vec2 fragUV;

        void main(){
            vec4 wpos   = modelMatrix * vec4( position, 1.0 );
            
            fragWPos    = wpos.xyz; // Pass worldspace position to fragment shader
            fragUV      = uv;       // Pass UV to worldspace position
            fragWNorm   = ( modelMatrix * vec4( normal, 0.0 ) ).xyz;
            
            gl_Position = projectionMatrix * viewMatrix * wpos;
        }`;

    this.fragmentShader = `precision mediump float;
        in vec3 fragWPos;
        in vec2 fragUV;
        in vec3 fragWNorm;
        
        out vec4 outColor;
        
        uniform vec3 color;
        uniform float opacity;

        void main(){
            outColor = vec4(color, opacity);
        }`;
  }
}
